// "use client"

// import { useState } from "react"
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   CircularProgress,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
// } from "@mui/material"
// import { Visibility, VisibilityOff } from "@mui/icons-material"
// import { styled } from "@mui/material/styles"
// import { useNavigate } from "react-router-dom"
// import Swal from "sweetalert2"
// import { motion } from "framer-motion"
// import Logo1 from "../landpageimage1/destinationlogo.png"
// import Logo2 from "../../src/landpageimage/TDTLLogo.png"
// import Logo3 from "../landpageimage1/mitlogo.jpg"
// import Logo4 from "../landpageimage1/startuplogo.png"

// // Orange and white theme colors
// const themeColors = {
//   primary: "#FF6B00",
//   secondary: "#FF9D45",
//   gradient: "linear-gradient(135deg, #FF6B00 0%, #FF9D45 100%)",
//   lightOrange: "#FFF3E0",
// }

// // Animated container for the form
// const AnimatedContainer = styled(motion.div)(() => ({
//   width: "100%",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
// }))

// const StyledPaper = styled(Paper)(() => ({
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   width: "90%",
//   maxWidth: "1200px",
//   margin: "0 auto",
//   borderRadius: "24px",
//   padding: "16px",
//   backgroundColor: themeColors.white,
//   boxShadow: "0 20px 40px rgba(255, 107, 0, 0.15)",
//   overflow: "hidden",
// }))

// const StyledTextField = styled(TextField)(() => ({
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "12px",
//     backgroundColor: themeColors.lightOrange,
//     transition: "all 0.3s ease",
//     "&:hover": {
//       backgroundColor: "#FFF8E1",
//       transform: "translateY(-2px)",
//     },
//     "&.Mui-focused": {
//       transform: "translateY(-2px)",
//       boxShadow: "0 4px 10px rgba(255, 107, 0, 0.15)",
//       "& fieldset": {
//         borderColor: themeColors.primary,
//       },
//     },
//   },
//   "& .MuiInputLabel-root": {
//     color: "#FF6B00",
//   },
// }))

// const RegisterButton = styled(Button)(() => ({
//   background: themeColors.gradient,
//   color: "white",
//   padding: "12px",
//   borderRadius: "16px",
//   fontWeight: 600,
//   transition: "all 0.3s ease",
//   "&:hover": {
//     background: themeColors.gradient,
//     transform: "translateY(-3px)",
//     boxShadow: "0 10px 20px rgba(255, 107, 0, 0.2)",
//   },
// }))

// const LogoContainer = styled(Box)(() => ({
//   display: "grid",
//   gridTemplateColumns: "repeat(4, 1fr)",
//   gap: "16px",
//   justifyContent: "center",
//   alignItems: "center",
//   width: "100%",
//   padding: "16px 0",
//   marginBottom: "16px",
//   "@media (max-width: 600px)": {
//     gridTemplateColumns: "repeat(2, 1fr)",
//   },
// }))

// const LogoImage = styled(motion.img)(() => ({
//   maxWidth: "100px",
//   maxHeight: "80px",
//   objectFit: "contain",
//   margin: "0 auto",
// }))

// const StyledFormControl = styled(FormControl)(() => ({
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "12px",
//     backgroundColor: themeColors.lightOrange,
//     transition: "all 0.3s ease",
//     "&:hover": {
//       backgroundColor: "#FFF8E1",
//       transform: "translateY(-2px)",
//     },
//     "&.Mui-focused": {
//       transform: "translateY(-2px)",
//       boxShadow: "0 4px 10px rgba(255, 107, 0, 0.15)",
//     },
//   },
//   "& .MuiInputLabel-root": {
//     color: "#FF6B00",
//   },
// }))

// // Animation variants
// const containerVariants = {
//   hidden: { opacity: 0 },
//   visible: {
//     opacity: 1,
//     transition: {
//       staggerChildren: 0.1,
//     },
//   },
// }

// const itemVariants = {
//   hidden: { y: 20, opacity: 0 },
//   visible: {
//     y: 0,
//     opacity: 1,
//     transition: {
//       type: "spring",
//       stiffness: 100,
//     },
//   },
// }

// const logoVariants = {
//   hover: {
//     scale: 1.1,
//     rotate: 5,
//     transition: {
//       type: "spring",
//       stiffness: 300,
//     },
//   },
// }

// function Stratupregister() {
//   const navigate = useNavigate()
//   const [showPassword, setShowPassword] = useState(false)
//   const [formData, setFormData] = useState({
//     full_name: "",
//     email: "",
//     password: "",
//     phone_number: "",
//     role: "Student",
//     // institution: "",
//     city: "",
//     state: "",
//     gender: "",
//     year_of_incorporation: "",
//     graduation_year: 2025,
//     website_or_linkedin_url: "",
//     post_graduation_degree: "",
//     graduation_degree: "",
//     is_group: "",
//     group_name: "",
//     group_members: "",
//     email2: "",
//     email3: "",
//     email4: "",
//     confirm_password: "",
//   })
//   const [errors, setErrors] = useState({})
//   const [loading, setLoading] = useState(false)

//   const validate = () => {
//     const newErrors = {}

//     if (!/^[a-zA-Z ]+$/.test(formData.full_name)) {
//       newErrors.full_name = "Full Name should contain only letters and spaces"
//     }
//     if (!/^[0-9]{10}$/.test(formData.phone_number)) {
//       newErrors.phone_number = "Phone Number should be exactly 10 digits"
//     }
//     if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       newErrors.email = "Invalid email address"
//     }
//     if (!/^[a-zA-Z ]{2,50}$/.test(formData.city)) {
//       newErrors.city = "City should contain only letters and spaces"
//     }
//     if (!/^[a-zA-Z ]{2,50}$/.test(formData.state)) {
//       newErrors.state = "State should contain only letters and spaces"
//     }
//     if (formData.password !== formData.confirm_password) {
//       newErrors.confirm_password = "Passwords do not match"
//     }
//     if (!/^\d{4}$/.test(formData.year_of_incorporation)) {
//         newErrors.year_of_incorporation = "Year of Incorporation should be a 4-digit number";
//       }
      
//     if (!/^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/.test(formData.website_or_linkedin_url)) {
//       newErrors.website_or_linkedin_url = "Invalid URL"
//     }

//     if (!formData.password) {
//       newErrors.password = "Password is required"
//     } else if (formData.password.length < 8) {
//       newErrors.password = "Password must be at least 8 characters"
//     }

//     if (formData.is_group === "True") {
//       const groupSize = Number.parseInt(formData.group_members, 10)
//       if (groupSize < 1 || groupSize > 4) {
//         newErrors.group_members = "Group size must be between 1 and 4"
//       }
//       ;["email2", "email3", "email4"].forEach((email, index) => {
//         if (formData[email] && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData[email])) {
//           newErrors[email] = `Invalid email for Team Member ${index + 2}`
//         }
//       })
//     }

//     setErrors(newErrors)
//     return Object.keys(newErrors).length === 0
//   }

//   const handleChange = (e) => {
//     const { name, value } = e.target
//     setFormData((prev) => ({ ...prev, [name]: value }))
//   }

//   const handleSubmit = async (e) => {
//     e.preventDefault()

//     if (!validate()) return

//     // Adjust payload for single participation
//     const updatedPayload = {
//       ...formData,
//       email2: formData.is_group === "False" ? "0" : formData.email2,
//       email3: formData.is_group === "False" ? "0" : formData.email3,
//       email4: formData.is_group === "False" ? "0" : formData.email4,
//       group_members: formData.is_group === "False" ? "0" : formData.group_members,
//       group_name: formData.is_group === "False" ? "0" : formData.group_name,
//     }

//     setLoading(true)
//     try {
//       const response = await fetch("https://puneexpobackend.tdtlworld.com/api/register_stud/", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(updatedPayload),
//       })
//       const data = await response.json()
//       if (response.ok) {
//         Swal.fire({
//           title: "Success!",
//           text: "Verify OTP for Confirmation of Registration.",
//           icon: "success",
//           timer: 2000,
//           showConfirmButton: false,
//           willClose: () => navigate("/Otpverification", { state: { email: formData.email } }),
//         })
//       } else {
//         Swal.fire({
//           title: "Error!",
//           text: data.msg || "Registration failed!",
//           icon: "error",
//           confirmButtonText: "Try Again",
//         })
//       }
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: "An error occurred. Please try again.",
//         icon: "error",
//         confirmButtonText: "Close",
//       })
//     } finally {
//       setLoading(false)
//     }
//   }

//   const graduationYears = [2000, ...Array.from({ length: 2027 - 2005 + 1 }, (_, i) => 2005 + i).reverse()]

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         background: themeColors.background,
//         padding: "16px",
//       }}
//     >
//       <AnimatedContainer initial="hidden" animate="visible" variants={containerVariants}>
//         <StyledPaper>
//           <LogoContainer>
//             {[Logo1, Logo2, Logo3, Logo4].map((logo, index) => (
//               <LogoImage key={index} src={logo} alt={`Logo ${index + 1}`} variants={logoVariants} whileHover="hover" />
//             ))}
//           </LogoContainer>

//           <motion.div
//             initial={{ opacity: 0, y: -20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.2, duration: 0.5 }}
//           >
//             <Typography
//               variant="h5"
//               fontWeight="bold"
//               mb={3}
//               sx={{
//                 color: "transparent",
//                 backgroundImage: themeColors.gradient,
//                 backgroundClip: "text",
//                 WebkitBackgroundClip: "text",
//                 textAlign: "center",
//                 fontSize: "1.5rem",
//               }}
//             >
//               Empower Your Stratup Journey – Register Today !
//             </Typography>
//           </motion.div>

//           <form onSubmit={handleSubmit} style={{ width: "100%" }}>
//             <Grid container spacing={2}>
//               {[
//                 "full_name",
//                 "email",
//                 "phone_number",
//                 "city",
//                 "state",
//                 // "institution",
//                 "year_of_incorporation",
//                 "website_or_linkedin_url",
//               ].map((field, index) => (
//                 <Grid item xs={12} sm={4} key={field}>
//                   <motion.div
//                     variants={itemVariants}
//                     initial="hidden"
//                     animate="visible"
//                     transition={{ delay: index * 0.05 }}
//                   >
//                     <StyledTextField
//                       fullWidth
//                       label={field
//                         .split("_")
//                         .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//                         .join(" ")}
//                       name={field}
//                       value={formData[field]}
//                       onChange={handleChange}
//                       required
//                       error={!!errors[field]}
//                       helperText={errors[field]}
//                     />
//                   </motion.div>
//                 </Grid>
//               ))}

//               <Grid item xs={12} sm={4}>
//                 <motion.div variants={itemVariants}>
//                   <StyledFormControl fullWidth>
//                     <InputLabel>Graduation Year</InputLabel>
//                     <Select name="graduation_year" value={formData.graduation_year} onChange={handleChange} required>
//                       {graduationYears.map((year) => (
//                         <MenuItem key={year} value={year}>
//                           {year === 2000 ? "Other" : year}
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </StyledFormControl>
//                 </motion.div>
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <motion.div variants={itemVariants}>
//                   <StyledTextField
//                     fullWidth
//                     label="Password"
//                     name="password"
//                     type={showPassword ? "text" : "password"}
//                     value={formData.password}
//                     onChange={handleChange}
//                     required
//                     error={!!errors.password}
//                     helperText={errors.password}
//                     InputProps={{
//                       endAdornment: (
//                         <InputAdornment position="end">
//                           <IconButton
//                             onClick={() => setShowPassword(!showPassword)}
//                             sx={{ color: themeColors.primary }}
//                           >
//                             {showPassword ? <VisibilityOff /> : <Visibility />}
//                           </IconButton>
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                 </motion.div>
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <motion.div variants={itemVariants}>
//                   <StyledTextField
//                     fullWidth
//                     label="Confirm Password"
//                     name="confirm_password"
//                     type="password"
//                     value={formData.confirm_password}
//                     onChange={handleChange}
//                     required
//                     error={!!errors.confirm_password}
//                     helperText={errors.confirm_password}
//                   />
//                 </motion.div>
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <motion.div variants={itemVariants}>
//                   <StyledFormControl fullWidth>
//                     <InputLabel>Gender</InputLabel>
//                     <Select name="gender" value={formData.gender} onChange={handleChange} required>
//                       <MenuItem value="M">Male</MenuItem>
//                       <MenuItem value="F">Female</MenuItem>
//                       <MenuItem value="O">Other</MenuItem>
//                     </Select>
//                   </StyledFormControl>
//                 </motion.div>
//               </Grid>

//               <Grid item xs={12} sm={6} md={4}>
//                 <motion.div variants={itemVariants}>
//                   <StyledFormControl fullWidth>
//                     <InputLabel>Graduation Degree</InputLabel>
//                     <Select
//                       name="graduation_degree"
//                       value={formData.graduation_degree}
//                       onChange={handleChange}
//                       required
//                     >
//                       {["BBA", "B. Com", "B.Sc.", "B. Tech/B.E.", "B.Arch.", "B.Pharm", "BFA", "Others", "NA"].map(
//                         (degree) => (
//                           <MenuItem key={degree} value={degree}>
//                             {degree}
//                           </MenuItem>
//                         ),
//                       )}
//                     </Select>
//                   </StyledFormControl>
//                 </motion.div>
//               </Grid>

//               <Grid item xs={12} sm={6} md={4}>
//                 <motion.div variants={itemVariants}>
//                   <StyledFormControl fullWidth>
//                     <InputLabel>Post-Graduation Degree</InputLabel>
//                     <Select
//                       name="post_graduation_degree"
//                       value={formData.post_graduation_degree}
//                       onChange={handleChange}
//                       required
//                     >
//                       {["MBA", "MCA", "PGDM", "M.Pharm", "M. Tech/M.E", "M.Sc.", "M. Arch", "Others", "NA"].map(
//                         (degree) => (
//                           <MenuItem key={degree} value={degree}>
//                             {degree}
//                           </MenuItem>
//                         ),
//                       )}
//                     </Select>
//                   </StyledFormControl>
//                 </motion.div>
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <motion.div variants={itemVariants}>
//                   <StyledFormControl fullWidth>
//                     <InputLabel>Participation Type</InputLabel>
//                     <Select name="is_group" value={formData.is_group} onChange={handleChange} required>
//                       <MenuItem value="False">Single Participation / Organization Participation</MenuItem>
//                       <MenuItem value="True">Group Participation</MenuItem>
//                     </Select>
//                   </StyledFormControl>
//                 </motion.div>
//               </Grid>

//               {formData.is_group === "True" && (
//                 <>
//                   <Grid item xs={12} sm={4}>
//                     <motion.div variants={itemVariants}>
//                       <StyledTextField
//                         fullWidth
//                         label="Group Name"
//                         name="group_name"
//                         value={formData.group_name}
//                         onChange={handleChange}
//                       />
//                     </motion.div>
//                   </Grid>

//                   <Grid item xs={12} sm={4}>
//                     <motion.div variants={itemVariants}>
//                       <StyledTextField
//                         fullWidth
//                         label="Group Members (limit 1-4 max)"
//                         name="group_members"
//                         value={formData.group_members}
//                         onChange={handleChange}
//                         type="number"
//                         inputProps={{ min: 1, max: 4 }}
//                       />
//                     </motion.div>
//                   </Grid>

//                   {formData.group_members >= 2 && (
//                     <Grid item xs={12} sm={4}>
//                       <motion.div
//                         initial={{ opacity: 0, height: 0 }}
//                         animate={{ opacity: 1, height: "auto" }}
//                         transition={{ duration: 0.3 }}
//                       >
//                         <StyledTextField
//                           fullWidth
//                           label="Email of Team Member 2"
//                           name="email2"
//                           value={formData.email2}
//                           onChange={handleChange}
//                           error={!!errors.email2}
//                           helperText={errors.email2}
//                         />
//                       </motion.div>
//                     </Grid>
//                   )}
//                   {formData.group_members >= 3 && (
//                     <Grid item xs={12} sm={4}>
//                       <motion.div
//                         initial={{ opacity: 0, height: 0 }}
//                         animate={{ opacity: 1, height: "auto" }}
//                         transition={{ duration: 0.3 }}
//                       >
//                         <StyledTextField
//                           fullWidth
//                           label="Email of Team Member 3"
//                           name="email3"
//                           value={formData.email3}
//                           onChange={handleChange}
//                           error={!!errors.email3}
//                           helperText={errors.email3}
//                         />
//                       </motion.div>
//                     </Grid>
//                   )}
//                   {formData.group_members >= 4 && (
//                     <Grid item xs={12} sm={4}>
//                       <motion.div
//                         initial={{ opacity: 0, height: 0 }}
//                         animate={{ opacity: 1, height: "auto" }}
//                         transition={{ duration: 0.3 }}
//                       >
//                         <StyledTextField
//                           fullWidth
//                           label="Email of Team Member 4"
//                           name="email4"
//                           value={formData.email4}
//                           onChange={handleChange}
//                           error={!!errors.email4}
//                           helperText={errors.email4}
//                         />
//                       </motion.div>
//                     </Grid>
//                   )}
//                 </>
//               )}

//               <Grid item xs={12}>
//                 <motion.div variants={itemVariants} whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
//                   <RegisterButton fullWidth type="submit" variant="contained" disabled={loading}>
//                     {loading ? (
//                       <CircularProgress size={24} sx={{ color: "white" }} />
//                     ) : (
//                       <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }}>
//                         Register Now
//                       </motion.span>
//                     )}
//                   </RegisterButton>
//                 </motion.div>
//               </Grid>
//             </Grid>
//           </form>
//         </StyledPaper>
//       </AnimatedContainer>
//     </Box>
//   )
// }

// export default Stratupregister



// import { useState } from "react"
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Paper,
//   CircularProgress,
//   Grid,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
// } from "@mui/material"
// import { Visibility, VisibilityOff } from "@mui/icons-material"
// import { styled } from "@mui/material/styles"
// import { useNavigate } from "react-router-dom"
// import Swal from "sweetalert2"
// import { motion } from "framer-motion"
// import Logo1 from "../landpageimage1/destinationlogo.png"
// import Logo2 from "../../src/landpageimage/TDTLLogo.png"
// import Logo3 from "../landpageimage1/mitlogo.jpg"
// import Logo4 from "../landpageimage1/startuplogo.png"

// // Orange and white theme colors
// const themeColors = {
//   primary: "#FF6B00",
//   secondary: "#FF9D45",
//   gradient: "linear-gradient(135deg, #FF6B00 0%, #FF9D45 100%)",
//   lightOrange: "#FFF3E0",
// }

// // Animated container for the form
// const AnimatedContainer = styled(motion.div)(() => ({
//   width: "100%",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
// }))

// const StyledPaper = styled(Paper)(() => ({
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   width: "90%",
//   maxWidth: "1200px",
//   margin: "0 auto",
//   borderRadius: "24px",
//   padding: "16px",
//   backgroundColor: themeColors.white,
//   boxShadow: "0 20px 40px rgba(255, 107, 0, 0.15)",
//   overflow: "hidden",
// }))

// const StyledTextField = styled(TextField)(() => ({
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "12px",
//     backgroundColor: themeColors.lightOrange,
//     transition: "all 0.3s ease",
//     "&:hover": {
//       backgroundColor: "#FFF8E1",
//       transform: "translateY(-2px)",
//     },
//     "&.Mui-focused": {
//       transform: "translateY(-2px)",
//       boxShadow: "0 4px 10px rgba(255, 107, 0, 0.15)",
//       "& fieldset": {
//         borderColor: themeColors.primary,
//       },
//     },
//   },
//   "& .MuiInputLabel-root": {
//     color: "#FF6B00",
//   },
// }))

// const RegisterButton = styled(Button)(() => ({
//   background: themeColors.gradient,
//   color: "white",
//   padding: "12px",
//   borderRadius: "16px",
//   fontWeight: 600,
//   transition: "all 0.3s ease",
//   "&:hover": {
//     background: themeColors.gradient,
//     transform: "translateY(-3px)",
//     boxShadow: "0 10px 20px rgba(255, 107, 0, 0.2)",
//   },
// }))

// const LogoContainer = styled(Box)(() => ({
//   display: "grid",
//   gridTemplateColumns: "repeat(4, 1fr)",
//   gap: "16px",
//   justifyContent: "center",
//   alignItems: "center",
//   width: "100%",
//   padding: "16px 0",
//   marginBottom: "16px",
//   "@media (max-width: 600px)": {
//     gridTemplateColumns: "repeat(2, 1fr)",
//   },
// }))

// const LogoImage = styled(motion.img)(() => ({
//   maxWidth: "100px",
//   maxHeight: "80px",
//   objectFit: "contain",
//   margin: "0 auto",
// }))

// const StyledFormControl = styled(FormControl)(() => ({
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "12px",
//     backgroundColor: themeColors.lightOrange,
//     transition: "all 0.3s ease",
//     "&:hover": {
//       backgroundColor: "#FFF8E1",
//       transform: "translateY(-2px)",
//     },
//     "&.Mui-focused": {
//       transform: "translateY(-2px)",
//       boxShadow: "0 4px 10px rgba(255, 107, 0, 0.15)",
//     },
//   },
//   "& .MuiInputLabel-root": {
//     color: "#FF6B00",
//   },
// }))

// // Animation variants
// const containerVariants = {
//   hidden: { opacity: 0 },
//   visible: {
//     opacity: 1,
//     transition: {
//       staggerChildren: 0.1,
//     },
//   },
// }

// const itemVariants = {
//   hidden: { y: 20, opacity: 0 },
//   visible: {
//     y: 0,
//     opacity: 1,
//     transition: {
//       type: "spring",
//       stiffness: 100,
//     },
//   },
// }

// const logoVariants = {
//   hover: {
//     scale: 1.1,
//     rotate: 5,
//     transition: {
//       type: "spring",
//       stiffness: 300,
//     },
//   },
// }

// function StartupRegister() {
//   const navigate = useNavigate()
//   const [showPassword, setShowPassword] = useState(false)
//   const [formData, setFormData] = useState({
//     full_name: "",
//     email: "",
//     password: "",
//     phone_number: "",
//     role: "Student",
//     city: "",
//     state: "",
//     gender: "",
//     year_of_incorporation: "",
//     graduation_year: 2025,
//     website_or_linkedin_url: "",
//     post_graduation_degree: "",
//     graduation_degree: "",
//     is_group: "",
//     group_name: "",
//     group_members: "",
//     email2: "",
//     email3: "",
//     email4: "",
//     confirm_password: "",
//   })
//   const [errors, setErrors] = useState({})
//   const [loading, setLoading] = useState(false)

//   const validate = () => {
//     const newErrors = {}

//     if (!/^[a-zA-Z ]+$/.test(formData.full_name)) {
//       newErrors.full_name = "Full Name should contain only letters and spaces"
//     }
//     if (!/^[0-9]{10}$/.test(formData.phone_number)) {
//       newErrors.phone_number = "Phone Number should be exactly 10 digits"
//     }
//     if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       newErrors.email = "Invalid email address"
//     }
//     if (!/^[a-zA-Z ]{2,50}$/.test(formData.city)) {
//       newErrors.city = "City should contain only letters and spaces"
//     }
//     if (!/^[a-zA-Z ]{2,50}$/.test(formData.state)) {
//       newErrors.state = "State should contain only letters and spaces"
//     }
//     if (formData.password !== formData.confirm_password) {
//       newErrors.confirm_password = "Passwords do not match"
//     }
//     if (!/^\d{4}$/.test(formData.year_of_incorporation)) {
//       newErrors.year_of_incorporation = "Year of Incorporation should be a 4-digit number"
//     }

//     if (!/^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/.test(formData.website_or_linkedin_url)) {
//       newErrors.website_or_linkedin_url = "Invalid URL"
//     }

//     if (!formData.password) {
//       newErrors.password = "Password is required"
//     } else if (formData.password.length < 8) {
//       newErrors.password = "Password must be at least 8 characters"
//     }

//     if (formData.is_group === "True") {
//       const groupSize = Number.parseInt(formData.group_members, 10)
//       if (groupSize < 1 || groupSize > 4) {
//         newErrors.group_members = "Group size must be between 1 and 4"
//       }
//       ;["email2", "email3", "email4"].forEach((email, index) => {
//         if (formData[email] && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData[email])) {
//           newErrors[email] = `Invalid email for Team Member ${index + 2}`
//         }
//       })
//     }

//     setErrors(newErrors)
//     return Object.keys(newErrors).length === 0
//   }

//   const handleChange = (e) => {
//     const { name, value } = e.target
//     setFormData((prev) => ({ ...prev, [name]: value }))
//   }

//   const handleSubmit = async (e) => {
//     e.preventDefault()

//     if (!validate()) return

//     // Adjust payload for single participation
//     const updatedPayload = {
//       ...formData,
//       email2: formData.is_group === "False" ? "0" : formData.email2,
//       email3: formData.is_group === "False" ? "0" : formData.email3,
//       email4: formData.is_group === "False" ? "0" : formData.email4,
//       group_members: formData.is_group === "False" ? "0" : formData.group_members,
//       group_name: formData.is_group === "False" ? "0" : formData.group_name,
//     }

//     setLoading(true)
//     try {
//       const response = await fetch("https://puneexpobackend.tdtlworld.com/startup/register_startup/", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(updatedPayload),
//       })
//       const data = await response.json()
//       if (response.ok) {
//         Swal.fire({
//           title: "Success!",
//           text: "Verify OTP for Confirmation of Registration.",
//           icon: "success",
//           timer: 2000,
//           showConfirmButton: false,
//           willClose: () => navigate("/Otpverification", { state: { email: formData.email } }),
//         })
//       } else {
//         Swal.fire({
//           title: "Error!",
//           text: data.msg || "Registration failed!",
//           icon: "error",
//           confirmButtonText: "Try Again",
//         })
//       }
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: "An error occurred. Please try again.",
//         icon: "error",
//         confirmButtonText: "Close",
//       })
//     } finally {
//       setLoading(false)
//     }
//   }

//   const graduationYears = [2000, ...Array.from({ length: 2027 - 2005 + 1 }, (_, i) => 2005 + i).reverse()]

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         background: themeColors.background,
//         padding: "16px",
//       }}
//     >
//       <AnimatedContainer initial="hidden" animate="visible" variants={containerVariants}>
//         <StyledPaper>
//           <LogoContainer>
//             {[Logo1, Logo2, Logo3, Logo4].map((logo, index) => (
//               <LogoImage key={index} src={logo} alt={`Logo ${index + 1}`} variants={logoVariants} whileHover="hover" />
//             ))}
//           </LogoContainer>

//           <motion.div
//             initial={{ opacity: 0, y: -20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.2, duration: 0.5 }}
//           >
//             <Typography
//               variant="h5"
//               fontWeight="bold"
//               mb={3}
//               sx={{
//                 color: "transparent",
//                 backgroundImage: themeColors.gradient,
//                 backgroundClip: "text",
//                 WebkitBackgroundClip: "text",
//                 textAlign: "center",
//                 fontSize: "1.5rem",
//               }}
//             >
//               Empower Your Startup Journey – Register Today!
//             </Typography>
//           </motion.div>

//           <form onSubmit={handleSubmit} style={{ width: "100%" }}>
//             <Grid container spacing={2}>
//               {[
//                 "full_name",
//                 "email",
//                 "phone_number",
//                 "city",
//                 "state",
//                 "year_of_incorporation",
//                 "website_or_linkedin_url",
//               ].map((field, index) => (
//                 <Grid item xs={12} sm={4} key={field}>
//                   <motion.div
//                     variants={itemVariants}
//                     initial="hidden"
//                     animate="visible"
//                     transition={{ delay: index * 0.05 }}
//                   >
//                     <StyledTextField
//                       fullWidth
//                       label={field
//                         .split("_")
//                         .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//                         .join(" ")}
//                       name={field}
//                       value={formData[field]}
//                       onChange={handleChange}
//                       required
//                       error={!!errors[field]}
//                       helperText={errors[field]}
//                     />
//                   </motion.div>
//                 </Grid>
//               ))}

//               <Grid item xs={12} sm={4}>
//                 <motion.div variants={itemVariants}>
//                   <StyledFormControl fullWidth>
//                     <InputLabel>Graduation Year</InputLabel>
//                     <Select name="graduation_year" value={formData.graduation_year} onChange={handleChange} required>
//                       {graduationYears.map((year) => (
//                         <MenuItem key={year} value={year}>
//                           {year === 2000 ? "Other" : year}
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </StyledFormControl>
//                 </motion.div>
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <motion.div variants={itemVariants}>
//                   <StyledTextField
//                     fullWidth
//                     label="Password"
//                     name="password"
//                     type={showPassword ? "text" : "password"}
//                     value={formData.password}
//                     onChange={handleChange}
//                     required
//                     error={!!errors.password}
//                     helperText={errors.password}
//                     InputProps={{
//                       endAdornment: (
//                         <InputAdornment position="end">
//                           <IconButton
//                             onClick={() => setShowPassword(!showPassword)}
//                             sx={{ color: themeColors.primary }}
//                           >
//                             {showPassword ? <VisibilityOff /> : <Visibility />}
//                           </IconButton>
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                 </motion.div>
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <motion.div variants={itemVariants}>
//                   <StyledTextField
//                     fullWidth
//                     label="Confirm Password"
//                     name="confirm_password"
//                     type="password"
//                     value={formData.confirm_password}
//                     onChange={handleChange}
//                     required
//                     error={!!errors.confirm_password}
//                     helperText={errors.confirm_password}
//                   />
//                 </motion.div>
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <motion.div variants={itemVariants}>
//                   <StyledFormControl fullWidth>
//                     <InputLabel>Gender</InputLabel>
//                     <Select name="gender" value={formData.gender} onChange={handleChange} required>
//                       <MenuItem value="M">Male</MenuItem>
//                       <MenuItem value="F">Female</MenuItem>
//                       <MenuItem value="O">Other</MenuItem>
//                     </Select>
//                   </StyledFormControl>
//                 </motion.div>
//               </Grid>

//               <Grid item xs={12} sm={6} md={4}>
//                 <motion.div variants={itemVariants}>
//                   <StyledFormControl fullWidth>
//                     <InputLabel>Graduation Degree</InputLabel>
//                     <Select
//                       name="graduation_degree"
//                       value={formData.graduation_degree}
//                       onChange={handleChange}
//                       required
//                     >
//                       {["BBA", "B. Com", "B.Sc.", "B. Tech/B.E.", "B.Arch.", "B.Pharm", "BFA", "Others", "NA"].map(
//                         (degree) => (
//                           <MenuItem key={degree} value={degree}>
//                             {degree}
//                           </MenuItem>
//                         ),
//                       )}
//                     </Select>
//                   </StyledFormControl>
//                 </motion.div>
//               </Grid>

//               <Grid item xs={12} sm={6} md={4}>
//                 <motion.div variants={itemVariants}>
//                   <StyledFormControl fullWidth>
//                     <InputLabel>Post-Graduation Degree</InputLabel>
//                     <Select
//                       name="post_graduation_degree"
//                       value={formData.post_graduation_degree}
//                       onChange={handleChange}
//                       required
//                     >
//                       {["MBA", "MCA", "PGDM", "M.Pharm", "M. Tech/M.E", "M.Sc.", "M. Arch", "Others", "NA"].map(
//                         (degree) => (
//                           <MenuItem key={degree} value={degree}>
//                             {degree}
//                           </MenuItem>
//                         ),
//                       )}
//                     </Select>
//                   </StyledFormControl>
//                 </motion.div>
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <motion.div variants={itemVariants}>
//                   <StyledFormControl fullWidth>
//                     <InputLabel>Participation Type</InputLabel>
//                     <Select name="is_group" value={formData.is_group} onChange={handleChange} required>
//                       <MenuItem value="False">Single Participation / Organization Participation</MenuItem>
//                       <MenuItem value="True">Group Participation</MenuItem>
//                     </Select>
//                   </StyledFormControl>
//                 </motion.div>
//               </Grid>

//               {formData.is_group === "True" && (
//                 <>
//                   <Grid item xs={12} sm={4}>
//                     <motion.div variants={itemVariants}>
//                       <StyledTextField
//                         fullWidth
//                         label="Group Name"
//                         name="group_name"
//                         value={formData.group_name}
//                         onChange={handleChange}
//                       />
//                     </motion.div>
//                   </Grid>

//                   <Grid item xs={12} sm={4}>
//                     <motion.div variants={itemVariants}>
//                       <StyledTextField
//                         fullWidth
//                         label="Group Members (limit 1-4 max)"
//                         name="group_members"
//                         value={formData.group_members}
//                         onChange={handleChange}
//                         type="number"
//                         inputProps={{ min: 1, max: 4 }}
//                       />
//                     </motion.div>
//                   </Grid>

//                   {formData.group_members >= 2 && (
//                     <Grid item xs={12} sm={4}>
//                       <motion.div
//                         initial={{ opacity: 0, height: 0 }}
//                         animate={{ opacity: 1, height: "auto" }}
//                         transition={{ duration: 0.3 }}
//                       >
//                         <StyledTextField
//                           fullWidth
//                           label="Email of Team Member 2"
//                           name="email2"
//                           value={formData.email2}
//                           onChange={handleChange}
//                           error={!!errors.email2}
//                           helperText={errors.email2}
//                         />
//                       </motion.div>
//                     </Grid>
//                   )}
//                   {formData.group_members >= 3 && (
//                     <Grid item xs={12} sm={4}>
//                       <motion.div
//                         initial={{ opacity: 0, height: 0 }}
//                         animate={{ opacity: 1, height: "auto" }}
//                         transition={{ duration: 0.3 }}
//                       >
//                         <StyledTextField
//                           fullWidth
//                           label="Email of Team Member 3"
//                           name="email3"
//                           value={formData.email3}
//                           onChange={handleChange}
//                           error={!!errors.email3}
//                           helperText={errors.email3}
//                         />
//                       </motion.div>
//                     </Grid>
//                   )}
//                   {formData.group_members >= 4 && (
//                     <Grid item xs={12} sm={4}>
//                       <motion.div
//                         initial={{ opacity: 0, height: 0 }}
//                         animate={{ opacity: 1, height: "auto" }}
//                         transition={{ duration: 0.3 }}
//                       >
//                         <StyledTextField
//                           fullWidth
//                           label="Email of Team Member 4"
//                           name="email4"
//                           value={formData.email4}
//                           onChange={handleChange}
//                           error={!!errors.email4}
//                           helperText={errors.email4}
//                         />
//                       </motion.div>
//                     </Grid>
//                   )}
//                 </>
//               )}

//               <Grid item xs={12}>
//                 <motion.div variants={itemVariants} whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
//                   <RegisterButton fullWidth type="submit" variant="contained" disabled={loading}>
//                     {loading ? (
//                       <CircularProgress size={24} sx={{ color: "white" }} />
//                     ) : (
//                       <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }}>
//                         Register Now
//                       </motion.span>
//                     )}
//                   </RegisterButton>
//                 </motion.div>
//               </Grid>
//             </Grid>
//           </form>
//         </StyledPaper>
//       </AnimatedContainer>
//     </Box>
//   )
// }

// export default StartupRegister


import { useState } from "react"
import {
  Box,
  Button,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  Paper,
  CircularProgress,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material"
import { Visibility, VisibilityOff } from "@mui/icons-material"
import { styled } from "@mui/material/styles"
import { useNavigate } from "react-router-dom"
import Swal from "sweetalert2"
import { motion } from "framer-motion"
import Logo1 from "../landpageimage1/destinationlogo.png"
import Logo2 from "../../src/landpageimage/TDTLLogo.png"
import Logo3 from "../landpageimage1/mitlogo.jpg"
import Logo4 from "../landpageimage1/startuplogo.png"

// Orange and white theme colors
const themeColors = {
  primary: "#FF6B00",
  secondary: "#FF9D45",
  gradient: "linear-gradient(135deg, #FF6B00 0%, #FF9D45 100%)",
  lightOrange: "#FFF3E0",
}

// Animated container for the form
const AnimatedContainer = styled(motion.div)(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}))

const StyledPaper = styled(Paper)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "90%",
  maxWidth: "1200px",
  margin: "0 auto",
  borderRadius: "24px",
  padding: "16px",
  backgroundColor: themeColors.white,
  boxShadow: "0 20px 40px rgba(255, 107, 0, 0.15)",
  overflow: "hidden",
}))

const StyledTextField = styled(TextField)(() => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    backgroundColor: themeColors.lightOrange,
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "#FFF8E1",
      transform: "translateY(-2px)",
    },
    "&.Mui-focused": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 10px rgba(255, 107, 0, 0.15)",
      "& fieldset": {
        borderColor: themeColors.primary,
      },
    },
  },
  "& .MuiInputLabel-root": {
    color: "#FF6B00",
  },
}))

const RegisterButton = styled(Button)(() => ({
  background: themeColors.gradient,
  color: "white",
  padding: "12px",
  borderRadius: "16px",
  fontWeight: 600,
  transition: "all 0.3s ease",
  "&:hover": {
    background: themeColors.gradient,
    transform: "translateY(-3px)",
    boxShadow: "0 10px 20px rgba(255, 107, 0, 0.2)",
  },
}))

const LogoContainer = styled(Box)(() => ({
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: "16px",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  padding: "16px 0",
  marginBottom: "16px",
  "@media (max-width: 600px)": {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
}))

const LogoImage = styled(motion.img)(() => ({
  maxWidth: "100px",
  maxHeight: "80px",
  objectFit: "contain",
  margin: "0 auto",
}))

const StyledFormControl = styled(FormControl)(() => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    backgroundColor: themeColors.lightOrange,
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "#FFF8E1",
      transform: "translateY(-2px)",
    },
    "&.Mui-focused": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 10px rgba(255, 107, 0, 0.15)",
    },
  },
  "& .MuiInputLabel-root": {
    color: "#FF6B00",
  },
}))

// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
}

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      type: "spring",
      stiffness: 100,
    },
  },
}

const logoVariants = {
  hover: {
    scale: 1.1,
    rotate: 5,
    transition: {
      type: "spring",
      stiffness: 300,
    },
  },
}

function StartupRegister() {
  const navigate = useNavigate()
  const [showPassword, setShowPassword] = useState(false)
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    password: "",
    phone_number: "",
    role: "Student",
    city: "",
    state: "",
    year_of_incorporation: "",
    website_or_linkedin_url: "",
    is_group: "",
    group_name: "",
    group_members: "",
    email2: "",
    email3: "",
    email4: "",
    confirm_password: "",
  })
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)

  const validate = () => {
    const newErrors = {}

    if (!/^[a-zA-Z ]+$/.test(formData.full_name)) {
      newErrors.full_name = "Full Name should contain only letters and spaces"
    }
    if (!/^[0-9]{10}$/.test(formData.phone_number)) {
      newErrors.phone_number = "Phone Number should be exactly 10 digits"
    }
    if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Invalid email address"
    }
    if (!/^[a-zA-Z ]{2,50}$/.test(formData.city)) {
      newErrors.city = "City should contain only letters and spaces"
    }
    if (!/^[a-zA-Z ]{2,50}$/.test(formData.state)) {
      newErrors.state = "State should contain only letters and spaces"
    }
    if (formData.password !== formData.confirm_password) {
      newErrors.confirm_password = "Passwords do not match"
    }
    if (!/^\d{4}$/.test(formData.year_of_incorporation)) {
      newErrors.year_of_incorporation = "Year of Incorporation should be a 4-digit number"
    }

    // Only validate website URL if it's not empty
    if (formData.website_or_linkedin_url && 
        !/^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/.test(formData.website_or_linkedin_url)) {
      newErrors.website_or_linkedin_url = "Invalid URL"
    }

    if (!formData.password) {
      newErrors.password = "Password is required"
    } else if (formData.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters"
    }

    if (formData.is_group === "True") {
      const groupSize = Number.parseInt(formData.group_members, 10)
      if (groupSize < 1 || groupSize > 4) {
        newErrors.group_members = "Group size must be between 1 and 4"
      }
      ;["email2", "email3", "email4"].forEach((email, index) => {
        if (formData[email] && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData[email])) {
          newErrors[email] = `Invalid email for Team Member ${index + 2}`
        }
      })
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!validate()) return

    // Set default dummy URL if empty
    const finalFormData = {
      ...formData,
      website_or_linkedin_url: formData.website_or_linkedin_url || "https://example.com"
    }

    // Adjust payload for single participation
    const updatedPayload = {
      ...finalFormData,
      email2: finalFormData.is_group === "False" ? "0" : finalFormData.email2,
      email3: finalFormData.is_group === "False" ? "0" : finalFormData.email3,
      email4: finalFormData.is_group === "False" ? "0" : finalFormData.email4,
      group_members: finalFormData.is_group === "False" ? "0" : finalFormData.group_members,
      group_name: finalFormData.is_group === "False" ? "0" : finalFormData.group_name,
    }

    // Remove fields that should not be in the payload
    const { 
      graduation_year, 
      post_graduation_degree, 
      graduation_degree, 
      gender, 
      ...payloadToSend 
    } = updatedPayload

    setLoading(true)
    try {
      const response = await fetch("https://puneexpobackend.tdtlworld.com/startup/register_startup/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payloadToSend),
      })
      const data = await response.json()
      if (response.ok) {
        Swal.fire({
          title: "Success!",
          text: "Verify OTP for Confirmation of Registration.",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
          willClose: () => navigate("/Otpverification", { state: { email: formData.email } }),
        })
      } else {
        Swal.fire({
          title: "Error!",
          text: data.msg || "Registration failed!",
          icon: "error",
          confirmButtonText: "Try Again",
        })
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "An error occurred. Please try again.",
        icon: "error",
        confirmButtonText: "Close",
      })
    } finally {
      setLoading(false)
    }
  }

  // Define required fields
  const requiredFields = [
    "full_name",
    "email",
    "phone_number",
    "city",
    "state",
    "year_of_incorporation",
  ]

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: themeColors.background,
        padding: "16px",
      }}
    >
      <AnimatedContainer initial="hidden" animate="visible" variants={containerVariants}>
        <StyledPaper>
          <LogoContainer>
            {[Logo1, Logo2, Logo3, Logo4].map((logo, index) => (
              <LogoImage key={index} src={logo} alt={`Logo ${index + 1}`} variants={logoVariants} whileHover="hover" />
            ))}
          </LogoContainer>

          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            <Typography
              variant="h5"
              fontWeight="bold"
              mb={3}
              sx={{
                color: "transparent",
                backgroundImage: themeColors.gradient,
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                textAlign: "center",
                fontSize: "1.5rem",
              }}
            >
              Empower Your Startup Journey – Register Today!
            </Typography>
          </motion.div>

          <form onSubmit={handleSubmit} style={{ width: "100%" }}>
            <Grid container spacing={2}>
              {/* Required fields */}
              {requiredFields.map((field, index) => (
                <Grid item xs={12} sm={4} key={field}>
                  <motion.div
                    variants={itemVariants}
                    initial="hidden"
                    animate="visible"
                    transition={{ delay: index * 0.05 }}
                  >
                    <StyledTextField
                      fullWidth
                      label={field
                        .split("_")
                        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(" ")}
                      name={field}
                      value={formData[field]}
                      onChange={handleChange}
                      required
                      error={!!errors[field]}
                      helperText={errors[field]}
                    />
                  </motion.div>
                </Grid>
              ))}

              {/* Website or LinkedIn URL - not required */}
              <Grid item xs={12} sm={4}>
                <motion.div
                  variants={itemVariants}
                  initial="hidden"
                  animate="visible"
                >
                  <StyledTextField
                    fullWidth
                    label="Website or LinkedIn URL"
                    name="website_or_linkedin_url"
                    value={formData.website_or_linkedin_url}
                    onChange={handleChange}
                    error={!!errors.website_or_linkedin_url}
                    helperText={errors.website_or_linkedin_url}
                  />
                </motion.div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <motion.div variants={itemVariants}>
                  <StyledTextField
                    fullWidth
                    label="Password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    value={formData.password}
                    onChange={handleChange}
                    required
                    error={!!errors.password}
                    helperText={errors.password}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowPassword(!showPassword)}
                            sx={{ color: themeColors.primary }}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </motion.div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <motion.div variants={itemVariants}>
                  <StyledTextField
                    fullWidth
                    label="Confirm Password"
                    name="confirm_password"
                    type="password"
                    value={formData.confirm_password}
                    onChange={handleChange}
                    required
                    error={!!errors.confirm_password}
                    helperText={errors.confirm_password}
                  />
                </motion.div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <motion.div variants={itemVariants}>
                  <StyledFormControl fullWidth>
                    <InputLabel>Participation Type</InputLabel>
                    <Select name="is_group" value={formData.is_group} onChange={handleChange} required>
                      <MenuItem value="False">Single Participation / Organization Participation</MenuItem>
                      <MenuItem value="True">Group Participation</MenuItem>
                    </Select>
                  </StyledFormControl>
                </motion.div>
              </Grid>

              {formData.is_group === "True" && (
                <>
                  <Grid item xs={12} sm={4}>
                    <motion.div variants={itemVariants}>
                      <StyledTextField
                        fullWidth
                        label="Group Name"
                        name="group_name"
                        value={formData.group_name}
                        onChange={handleChange}
                      />
                    </motion.div>
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <motion.div variants={itemVariants}>
                      <StyledTextField
                        fullWidth
                        label="Group Members (limit 1-4 max)"
                        name="group_members"
                        value={formData.group_members}
                        onChange={handleChange}
                        type="number"
                        inputProps={{ min: 1, max: 4 }}
                      />
                    </motion.div>
                  </Grid>

                  {formData.group_members >= 2 && (
                    <Grid item xs={12} sm={4}>
                      <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        transition={{ duration: 0.3 }}
                      >
                        <StyledTextField
                          fullWidth
                          label="Email of Team Member 2"
                          name="email2"
                          value={formData.email2}
                          onChange={handleChange}
                          error={!!errors.email2}
                          helperText={errors.email2}
                        />
                      </motion.div>
                    </Grid>
                  )}
                  {formData.group_members >= 3 && (
                    <Grid item xs={12} sm={4}>
                      <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        transition={{ duration: 0.3 }}
                      >
                        <StyledTextField
                          fullWidth
                          label="Email of Team Member 3"
                          name="email3"
                          value={formData.email3}
                          onChange={handleChange}
                          error={!!errors.email3}
                          helperText={errors.email3}
                        />
                      </motion.div>
                    </Grid>
                  )}
                  {formData.group_members >= 4 && (
                    <Grid item xs={12} sm={4}>
                      <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        transition={{ duration: 0.3 }}
                      >
                        <StyledTextField
                          fullWidth
                          label="Email of Team Member 4"
                          name="email4"
                          value={formData.email4}
                          onChange={handleChange}
                          error={!!errors.email4}
                          helperText={errors.email4}
                        />
                      </motion.div>
                    </Grid>
                  )}
                </>
              )}

              <Grid item xs={12}>
                <motion.div variants={itemVariants} whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
                  <RegisterButton fullWidth type="submit" variant="contained" disabled={loading}>
                    {loading ? (
                      <CircularProgress size={24} sx={{ color: "white" }} />
                    ) : (
                      <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }}>
                        Register Now
                      </motion.span>
                    )}
                  </RegisterButton>
                </motion.div>
              </Grid>
            </Grid>
          </form>
        </StyledPaper>
      </AnimatedContainer>
    </Box>
  )
}

export default StartupRegister